/**
 * Tiny pub/sub for "a navigation is in flight". NavProgress flips it on when a
 * link/search is triggered and off when the new URL commits; the board's
 * ResultsLoadingOverlay subscribes to dim results + show a spinner. Keeping it a
 * plain module store (not context) lets a server-rendered results tree opt in
 * via one thin client wrapper, with no provider threading.
 */
type Listener = (loading: boolean) => void;

let loading = false;
const listeners = new Set<Listener>();

export function setNavLoading(value: boolean): void {
  if (loading === value) return;
  loading = value;
  for (const l of listeners) l(value);
}

export function getNavLoading(): boolean {
  return loading;
}

export function subscribeNavLoading(l: Listener): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
